import { combineReducers } from "redux";

import { isLoaderReducer } from "./isLoaderReducer/isLoaderReducer";
import { userInfoReducer } from "./userInfoReducer/userInfoReducer";
import { appConfigsReducer } from "./appConfigsReducer/appConfigsReducer";
import { citiesReducer } from "./citiesReducer/citiesReducer";
import { permissionReducer } from "./permissionReducer/permissionReducer";
import { socketReducer } from "./socketReducer/socketReducer";

export const reducers = combineReducers({
  isLoader: isLoaderReducer,
  userInfo: userInfoReducer,
  cities: citiesReducer,
  appConfigs: appConfigsReducer,
  permission: permissionReducer,
  socket: socketReducer,
});
